import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createPendingStatus = ( {data} : {data: IPostNewPendingStatus | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/PendingStatus/InsertPendingStatus`, data);
};

type QueryFnType = typeof createPendingStatus;

type UseCreatePendingStatusOptions = {
  data: IPostNewPendingStatus | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreatePendingStatus = ({ config }: UseCreatePendingStatusOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Κατηγορίας Εκκρεμότητας.`, 500);
            console.error('Couldnt create new PendingStatus', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPendingStatus"])
            addNotification("Δημιουργήθηκε Νέα Κατηγορία Εκκρεμότητας.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createPendingStatus,
    })
}